import { useState } from 'react';
import { FiMove } from 'react-icons/fi';

// Preview order locally, just like the media library. Only a drop changes the draft.
export default function AdminReorderList({ items, onChange, itemLabel, rowClassName = '', children }) {
  const [drag, setDrag] = useState(null);
  const active = drag?.items === items ? drag : null;
  const order = active?.order || items.map((_, index) => index);

  function enter(index, event) {
    if (event.currentTarget.contains(event.relatedTarget)) return;
    setDrag(current => {
      if (!current || current.items !== items || current.index === index) return current;
      const next = [...current.order];
      const from = next.indexOf(current.index);
      const to = next.indexOf(index);
      next.splice(from, 1);
      next.splice(to, 0, current.index);
      return { ...current, order: next };
    });
  }

  return <div
    className={`admin-repeater-list admin-sortable-list${active ? ' is-sorting' : ''}`}
    onDragOver={event => {
      if (!active) return;
      event.preventDefault();
      event.dataTransfer.dropEffect = 'move';
    }}
    onDrop={event => {
      if (!active) return;
      event.preventDefault();
      setDrag(null);
      if (active.order.some((index, position) => index !== position)) onChange(active.order.map(index => items[index]));
    }}
  >
    {order.map((index, position) => {
      const label = `${itemLabel} ${position + 1}`;
      const handle = <span
        className={`admin-reorder-handle${items.length > 1 ? ' admin-drag-source' : ''}`}
        draggable={items.length > 1}
        title={items.length > 1 ? `Drag ${label.toLowerCase()} to reorder` : undefined}
        onDragStart={event => {
          if (items.length < 2) { event.preventDefault(); return; }
          event.dataTransfer.effectAllowed = 'move';
          event.dataTransfer.setData('text/plain', label);
          const row = event.currentTarget.closest('.admin-sortable-item');
          const bounds = row.getBoundingClientRect();
          event.dataTransfer.setDragImage?.(row, event.clientX - bounds.left, event.clientY - bounds.top);
          setDrag({ items, index, order: items.map((_, itemIndex) => itemIndex) });
        }}
        onDragEnd={() => setDrag(null)}
      ><FiMove aria-hidden="true" /><span>{label}</span></span>;
      return <div
        key={index}
        className={`admin-repeater-row admin-sortable-item ${rowClassName}${active?.index === index ? ' is-dragging' : ''}`}
        onDragEnter={event => enter(index, event)}
      >{children({ item: items[index], index, position, handle })}</div>;
    })}
    {active && <p className="admin-drag-status" role="status">
      New position {active.order.indexOf(active.index) + 1} of {items.length}. Release to reorder, then publish to save.
    </p>}
  </div>;
}
